/* ss-abbinamenti.js — chiede a Shopify cosa si compra insieme a questo prodotto.
   Nessuna app: e' l'endpoint nativo dei suggerimenti. */
(function () {
  var sec = document.querySelector('[data-ss-abb]');
  if (!sec) return;
  var grid = sec.querySelector('[data-abb-grid]');
  var pid  = sec.getAttribute('data-pid');
  var lim  = sec.getAttribute('data-limit') || 4;
  if (!pid) return;

  fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + lim)
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var p = (d && d.products) || [];
      if (!p.length) return;
      grid.innerHTML = p.map(function (x) {
        var img = x.featured_image ? x.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_700x700_crop_center$1$2') : '';
        /* niente prezzo qui: i tessuti sono a mezzo metro e i pezzi a unita',
           mostrarli affiancati senza unita' confonderebbe */
        /* seconda foto «in utilizzo», se c'e': stessa regola delle card Liquid */
        var uso = (x.images && x.images[1] && /-in-utilizzo/.test(x.images[1]))
          ? x.images[1].replace(/(\.[a-z]+)(\?|$)/i, '_700x700_crop_center$1$2') : '';
        var usoHtml = uso ? '<img class="ss-card__uso" src="' + uso + '" alt="' + x.title + ' in uso" loading="lazy">' +
          '<span class="ss-card__flip" data-flip aria-hidden="true">In uso</span>' : '';
        return '<a class="ss-card" href="' + x.url + '">' +
          '<div class="ss-card__media">' + (img ? '<img src="' + img + '" alt="' + x.title + '" loading="lazy">' + usoHtml : '<div class="ss-card__ph"></div>') + '</div>' +
          '<div class="ss-card__body"><p class="ss-card__n">' + x.title + '</p>' +
          '<div class="ss-card__row"><span>Guarda</span>' +
          '<span class="ss-card__price">&rarr;</span></div></div></a>';
      }).join('');
      sec.hidden = false;
    })
    .catch(function () { /* se non arriva niente, la fascia resta nascosta */ });
})();
